const editPrivacyPolicyConstantsEn = {
  privacyPolicyPageTitle: 'Privacy Policy and Cookies Policy',
  privacyPolicyBreadcrumb: 'Privacy Policy and Cookies Policy',
};

export default editPrivacyPolicyConstantsEn;
